'use client';

import { c as _c } from "react/compiler-runtime";
import type React from 'react';
import MuiSelect, { type SelectChangeEvent } from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { useState } from 'react';
import { styled } from '@mui/material/styles';
import { InputLabel } from 'src/components/Atoms/InputLabel';
import { FormControl } from 'src/components/Molecules/FormControl';
interface SelectOption {
  value: string;
  text: string;
}
const StyledFormControl = styled(FormControl)(() => ({
  '&.MuiFormControl-root': {
    alignSelf: 'unset'
  }
}));
interface InputSelectProps {
  label?: string;
  placeholder?: string;
  value?: string | number;
  onChange?: (e: string) => void;
  name?: string;
  disabled?: boolean;
  required?: boolean;
  options?: SelectOption[];
  showInlineLabel?: boolean;
}
const InputSelect: React.FC<InputSelectProps> = t0 => {
  const $ = _c(21);
  const {
    label,
    value: t1,
    onChange,
    name,
    disabled: t2,
    required: t3,
    options: t4,
    showInlineLabel: t5
  } = t0;
  const value = t1 === undefined ? "" : t1;
  const disabled = t2 === undefined ? false : t2;
  const required = t3 === undefined ? false : t3;
  let t6;
  if ($[0] !== t4) {
    t6 = t4 === undefined ? [] : t4;
    $[0] = t4;
    $[1] = t6;
  } else {
    t6 = $[1];
  }
  const options = t6;
  const showInlineLabel = t5 === undefined ? false : t5;
  const [currentValue, setCurrentValue] = useState(value);
  let t7;
  if ($[2] !== onChange) {
    t7 = event => {
      const newValue = event.target.value as string;
      setCurrentValue(newValue);
      onChange?.(newValue);
    };
    $[2] = onChange;
    $[3] = t7;
  } else {
    t7 = $[3];
  }
  const handleOnChange = t7;
  let t8;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      alignSelf: "unset"
    };
    $[4] = t8;
  } else {
    t8 = $[4];
  }
  let t9;
  if ($[5] !== label || $[6] !== showInlineLabel) {
    t9 = label && !showInlineLabel && <InputLabel>{label}</InputLabel>;
    $[5] = label;
    $[6] = showInlineLabel;
    $[7] = t9;
  } else {
    t9 = $[7];
  }
  const t10 = label && showInlineLabel ? label : undefined;
  let t11;
  if ($[8] !== options) {
    t11 = options.map(_temp);
    $[8] = options;
    $[9] = t11;
  } else {
    t11 = $[9];
  }
  let t12;
  if ($[10] !== currentValue || $[11] !== disabled || $[12] !== handleOnChange || $[13] !== name || $[14] !== required || $[15] !== t10 || $[16] !== t11) {
    t12 = <MuiSelect value={currentValue} name={name} onChange={handleOnChange} disabled={disabled} required={required} label={t10}>{t11}</MuiSelect>;
    $[10] = currentValue;
    $[11] = disabled;
    $[12] = handleOnChange;
    $[13] = name;
    $[14] = required;
    $[15] = t10;
    $[16] = t11;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] !== t12 || $[19] !== t9) {
    t13 = <StyledFormControl variant="standard" sx={t8}>{t9}{t12}</StyledFormControl>;
    $[18] = t12;
    $[19] = t9;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  return t13;
};
export default InputSelect;
export type { InputSelectProps, SelectOption };
function _temp(option) {
  return <MenuItem key={option.value} value={option.value}>{option.text}</MenuItem>;
}